import { components } from "react-select";
import Select from "react-select";

import { useCheckoutContext } from "@payment/providers/CheckoutProvider/useCheckoutContext";

import listOfCountries from "../listOfCountries.json";
import { OptionsLabel } from "./OptionsLabel";
import { CustomSelect } from "./styles";

interface IOptionsLabelSelect {
  name: string;
  flag: string;
  ddi: string;
}

type SelectProps = {
  handleChange: (option: IOptionsLabelSelect | null) => void;
  placeholder?: string;
  noOptionsMessage?: () => string;
  isInvalid?: boolean;
  isClearable?: boolean;
  isDisabled?: boolean;
};

const SelectCountry = ({
  handleChange,
  placeholder,
  isInvalid,
  isClearable,
  isDisabled,
}: SelectProps) => {
  const Placeholder = (props: any) => {
    return (
      <components.Placeholder {...props}>
        <div className="placeholder">{placeholder}</div>
      </components.Placeholder>
    );
  };
  const { country } = useCheckoutContext();

  const defaultCountry =
    listOfCountries?.countries.find((c) => c.name === country) ||
    listOfCountries?.countries.find((c) => c.name === "Brasil");

  return (
    <CustomSelect isInvalid={isInvalid}>
      <Select
        options={listOfCountries?.countries}
        placeholder={placeholder}
        onChange={(selectedOption: IOptionsLabelSelect | null) =>
          handleChange(selectedOption)
        }
        classNamePrefix="react-select"
        formatOptionLabel={OptionsLabel}
        components={{ Placeholder }}
        defaultValue={defaultCountry}
        isClearable={isClearable}
        isDisabled={isDisabled}
        isSearchable={false}
      />
    </CustomSelect>
  );
};

export default SelectCountry;
